<div mat-dialog-content>
  <div *ngIf="showSpinner" class="d-flex flex-column align-items-center justify-content-center p-4">
    <mat-spinner [diameter]="50" class="mb-3"></mat-spinner>
    <h3 class="text-center" [innerHTML]="msg">
    </h3>
  </div>
  <h3 *ngIf="!showSpinner" [innerHTML]="msg">
  </h3>
</div>
<div mat-dialog-actions align="center" [hidden]="hideButtons">
  <button class="btn-primary-mat" *ngIf="showYes" (click)="answerClick(1)"
    cdkFocusInitial>{{ yesText }}</button>
  <button class="btn-secondary-dialog" mat-button [hidden]="this.noText=='' || this.noText==null" (click)="answerClick(0)">{{noText}}</button>
</div>
